export const referenceNo={label:'Reference NO.',name:'referenceNo'};
export const s={label:'Reference NO.',name:'referenceNo'};
export const periodFrom={label:'Period from',name:'startDate'};
export const to={label:'to',name:'endDate'};
export const status={label:'Status',name:'status'};
export const all={label:'All'};
export const userGuide={label:'User Guide'};
export const size={label:'Size'};
export const type={label:'Type'};
export const updateDate={label:'Update Date'};
export const downloadCount={label:'Download Count'};
export const operation={label:'Operation'};
export const operationDate = {label:'Operation Date',name:'operationDate'};
export const operationTime = {label:'Operation Time',name:'operationDate'};

//列表共用
export const noIndex={label:'NO.'};
export const sNo={label:'S/NO'};

//分页
export const pageOf={label:'of'};
export const pageItems={label:'items'};

//按钮名称共用
export const addButton={label:'Add'};
export const modifyButton={label:'Modify'};
export const deleteButton={label:'Delete'};
export const viewOperationLogsButton={label:'View Operation Logs'};
export const voidButton={label:'Void'};
export const historyButton={label:'History'};
export const viewButton={label:'View'};
export const viewPdfButton={label:'View Invoice PDF'};
export const exportButton={label:'Export'};
export const checkIncompletedButton={label:'Check Incompleted Fields'};
export const exportQRCode={label:'Export QR Code List'};
export const viewDetails={label:'View Details'};
export const discountButton={label:'Discount'};
export const nextButton={label:'Next'};
export const resetButton={label:'Reset'};
export const previousButton={label:'Previous'};
export const previewButton={label:'Preview'};
export const confirmButton={label:'Confirm'};
export const cancelButton={label:'Cancel'};
export const rejectButton={label:'Reject'};
export const saveButton={label:'Save'};
export const submitButton={label:'Submit'};
export const searchButton={label:'Search'};
export const expandButton={label:'Expand'};
export const closeButton={label:'Close'};
export const selectButton={label:'Select'};
export const uploadButton={label:'Upload'};
export const applyButton={label:'Apply'};
export const handleButton={label:'Handle'};
export const backButton={label:'Back'};
export const enableButton={label:'Enable'};
export const disableButton={label:'Disable'};
export const okButton={label:'OK'};
export const nextItemButton={label:'Add Next Item'};
export const batchImportButton={label:'Batch Import'};
export const printButton={label:'Print'};
export const downloadButton={label:'Download'};
export const refreshButton={label:'Refresh'};
export const approveButton={label:'Approve'};
export const advancedButton={label:"Advanced Search"};
export const basicButton={label:"Basic Search"};
export const downloadTemp={label:"Download Template"};
export const shareButton={label:"Share Invoice PDF"};
export const debitNoteBtn={label:"Request Debit Note"}
export const creditNoteBtn={label:"Request Credit Note"}
export const refundNoteBtn={label:"Request Refund Note"}
export const invoicePreviewBtn={label:"Invoice Preview"}
export const viewTransDataBtn={label:"View Transaction Data"}
export const downloadFailedFiles={label:"Download Failed Files"}
//提示语共用
export const noDataExport={label:'The list has no data and cannot be exported'};
export const deleteConfirmTip={label:'Are you sure you want to delete the data?'};
export const pleaseLoginTip={label:'Please login!'};
export const confirmTitle={label:'Confirm'};
export const deleteTitle={label:'Delete'};
export const saveConfirm={label:'Are you sure you want to save?'};
export const submitConfirm={label:'Are you sure you want to submit?'};
export const cancelConfirm={label:'Are you sure you want to cancel?'};
export const closeConfirm={label:'Are you sure you want to close?'};
export const voidConfirm={label:'Are you sure you want to void the data?'};
export const voidTip={label:'Are you sure you want to void the data ?'};
export const pleaseSelect={label:'Please Select'};
export const enableData={label:'Are you sure you want to enable this data?'};
export const disableData={label:'Are you sure you want to disable this data?'};
export const canNotBeZero={label:'can not be zero.'};
export const queryDateCanNotExceedOneYear={label:'The query date cannot be empty and the query period cannot exceed one year!'};
export const isRequiredTip={label:' is required'};
export const isCanNotEmptyTip={label:' cannot be empty'};
export const lengthMustBeLessThan={label:' length must be less than'};
export const lengthMustBeGreaterThan={label:' length must be greater than '};
export const notValidEmail={label:' is not a valid email'};
export const networkFailed={label:'Network connection is failed!'};
export const satisfactionSurvey={label:'Whether participate in the satisfaction survey?'};
export const enterKeywords={label:'Please enter keywords'};


//上传附件
export const supportingDocument={label:'Supporting Document'};
export const uploadFirstTip={label:'Please upload attachment first.'};
export const operationFailed={label:'Operation failed, please try again.'};
export const operationSuccess={label:'Successfully operated!'};

export const step={label:"Step"};
export const operator={label:"Operator"};
export const operatorTime={label:"Operation Time"};
export const approved={label:"Approved"};
export const rejected={label:"Rejected"};
export const enterOnlyDigits="Please enter only digits";
export const applicationDate="Application Date";
export const applicationStatus="Application Status";
export const approveDate="Approval Date";
export const waitingTime="Waiting Time";
export const systemPrompt="System Prompt";
export const mobileNumberPreIsRequired="Mobile Number Pre is required";
export const queryResultsAreEmpty="The query results are empty";
export const enterEmailAddress="Please enter a  valid email address";
export const selectOneRecordTip="Please select one record.";
export const prompt="Prompt";
export const successfullySubmitted="Successfully submitted!";
export const successfullyOperated="Successfully operated!";
export const operationFailedCommon="Operation Failed!";
export const start="Start";
export const submitted="Submitted";
export const end="End";
export const approvedOrRejected="Approved/Rejected";
export const total="Total";
export const checkAll="Check All";
export const successfullySaved="Successfully saved!";
export const isRequired="is required";
export const completed="Completed";


export const attachmentName="Attachment Name";
export const isItRequired="Is It Required";
export const quantity="Quantity";
export const fileType="File Type";
export const viewUploadedAttachment="View Uploaded Attachment";
export const upload="Upload";
export const uploadAttachment="Upload Attachment";
export const fileIsNotAllowedDelete="The file is not allowed to be deleted";
export const viewDMS="View DMS";
export const acknowledgeNO="Acknowledge NO.";
export const taxAuthority="Tax Authority";
export const documentType="Document Type";
export const fileName="File Name";
export const dateOfSubmission="Date of Submission";
export const attachmentTypeIsNotAllowedToUpload="Attachment type is not allowed to upload!";
export const cannotUploadAnEmptyFile="Cannot upload an empty file !";
export const attachmentSizeIsTooLarge="Attachment size is too large!";
export const failedToDelete="failed to delete!";

export const remarks={label:'Remarks',name:'remarks'};
export const selectDate={label:'Select date'};
export const businessCategory= "Business Category";
export const trackYourStatus= "Track Your Status";
export const dateFrom="Date from";
export const cannotVoidTip="The apply status has been changed, please try again.";
export const goodsCode = {label:'My Product Code:'};
export const itemLabel = {label:'Item:'};


export const tin = {label:"TIN",name:"tin"};
export const name = {label:"Name",name:"name"};

export const clientID = {label:"Client ID",name:"clientId"};
export const SecretID = {label:"Secret ID",name:"clientSecret"};
export const clientTitle ={label:"LHDNM Credential"};
export const operationLog = {label:"Operation Log"};

export const pwdIncorrect="The password format is incorrect.";
export const pwdHasSpecialCharacter="Please do not include the following special characters: / \\ \" ‘ {}  [] , : ;";
export const pwdHasSpecialCharacter2="Special characters are not allowed to be entered:/\\ \"'{} [],:;";
export const contactNumIncorrect="The contact number format is incorrect.";

export const queryDateCannotBeEmpty="The query date cannot be empty.";
export const queryPeriodCannotExceed1="The query period cannot exceed ";
export const queryPeriodCannotExceed2=" days.";
export const pwdFormatIncorrect="6-20 digits, with at least 3 types of uppercase and lowercase letters/numbers/special characters.";
export const passwordIsDifferentFromNewPassword="Confirm password is different from new password!";
export const newPasswordCanTSetTheSameAsTheOriginalOne="The new password can't set the same as the original one!";
export const accountNotExist="Account does not exist!";
export const emailNotEmpty="Email cannot be empty!";
export const emailIncorrect="Incorrect email format";
export const otpNotEmpty="OTP cannot be empty!";
export const otpExpired="OTP has expired!";
export const otpIncorrect="Incorrect OTP!";
export const invalidOTP="Invalid OTP";
export const registerSuccess="Registration successful, please log in.Login account:";
export const register="Register";
export const enterYourUserName="Please enter your user name.";
export const enterYourContactNumber="Please enter your contact number.";
export const validEmailAddress="Please provide a valid email address as the account";
export const emailHasBeenRegistered="The email has been registered";
export const drawerTip="Note: Please select one or more companies to view their relevant financial data.";


export const loading="loading...";
export const noData="No Data";
export const exportDataCannotExceed="Export data cannot exceed: ";
export const dataExportPleaseWait="Data export, please wait......";
export const logTitle="Operation Log";
export const saveFailed="save failed!"
export const basicInfoTaxpayerNoMaintained="The basic information of the taxpayer has not been maintained.";
export const failSubmitTryLater="Failed submission, please try again later.";
export const progressTip="Progress:";
export const loginAgain="Page not operated for a long time, please log in again";
export const qrScannerTip="Unable to recognize the QR code in the file, please try another method.";
export const noPermission="No Permission";
export const downloadTaskInitiated='The data download task has been initiated, please check the progress of the task in the "Download Task" menu later.';
